/**
 * DI singleton for accessing stores
 * @module
 */

var _ = require('optimizely-client-fn');
var DIFactory = require('./lib/di_factory');
var Flux = require('./flux');
var keyValueMatcher = require('./plugins/matchers/key_value');

var di = DIFactory.create();

var STORES = {
  'action_data': require('./stores/action_data'),
  'async_request': require('./stores/async_request'),
  'audience_data': require('./stores/audience_data'),
  'change_data': require('./stores/change_data'),
  'cleanup': require('./stores/cleanup'),
  'client_metadata': require('./stores/client_metadata'),
  'cookie_options': require('./stores/cookie_options'),
  'event_data': require('./stores/event_data'),
  'event_emitter': require('./stores/event_emitter'),
  'dimension_data': require('./stores/dimension_data'),
  'directive': require('./stores/directive'),
  'global': require('./stores/global'),
  'history': require('./stores/history'),
  'integration_settings': require('./stores/integration_settings'),
  'layer': require('./stores/layer'),
  'layer_data': require('./stores/layer_data'),
  'log': require('./stores/log'),
  'observed_redirect': require('./stores/observed_redirect'),
  'pending_events': require('./stores/pending_events'),
  'performance': require('./stores/performance'),
  'plugins': require('./stores/plugins'),
  'provider_status': require('./stores/provider_status'),
  'pending_redirect': require('./stores/pending_redirect'),
  'rum': require('./stores/rum'),
  'sandbox': require('./stores/sandbox'),
  'session': require('./stores/session'),
  'tracker_optimizely': require('./stores/tracker_optimizely'),
  'ua_data': require('./stores/ua_data'),
  'view': require('./stores/view'),
  'view_data': require('./stores/view_data'),
  'visitor': require('./stores/visitor'),
  'visitor_attribute_entity': require('./stores/visitor_attribute_entity'),
  'visitor_events': require('./stores/visitor_events'),
  'visitor_events_manager': require('./stores/visitor_events_manager'),
  'visitor_id': require('./stores/visitor_id'),
  'visitor_bucketing': require('./stores/visitor_bucketing'),
  'xdomain': require('./stores/xdomain'),
};

if (__GROUPS__) {
  STORES['group_data'] = require('./stores/group_data');
}

if (__TARGETING_CONDITIONS__.PREDICTED_INTENT) {
  // Stores specific to a particular plugin. See CJS-1011.
  STORES['interest_group'] = require('./stores/interest_group');
  STORES['tag_group'] = require('./stores/tag_group');
}

Flux.registerStores(STORES);

// register store with DI system
_.forOwn(STORES, function(store, id) {
  di.register('stores/' + id, Flux.getStore(id));
});

// Consumed, at least, by custom audience integrations
di.register('core/plugins/matchers/key_value', keyValueMatcher);

module.exports = di;
